import DefaultLayout from '../views/Layouts/DefaultLayout';
import AccountLayout from '../views/Layouts/AccountLayout';
import ExchangeLayout from '../views/Layouts/ExchangeLayout';

let Home = () => import('../views/Home');
let Login = () => import('../views/Account/Login');
let Register = () => import('../views/Account/Register/Register.vue');
let ForgetPwd = () => import('../views/Account/ForgetPwd/ForgetPwd.vue');
let Reactivation = () => import('../views/Account/Reactivation/Reactivation.vue');
// 用户中心
let UserCenter = () => import('@/views/UserCenter/index');
let AccountManagement = () => import('@/views/UserCenter/AccountManagement/AccountManagement.vue');
let Authentication = () => import('@/views/UserCenter/Authentication/Authentication.vue');
let RealName = () => import('@/views/UserCenter/Realname/Realname.vue');
// let RealNameInfo = () => import('../views/UserCenter/realname-info/RealnameInfo.vue');
// let SeniorCertification = () => import('../views/UserCenter/senior-certification/SeniorCertification.vue');
// let SeniorCertificationInfo = () => import('../views/UserCenter/senior-certification-info/SeniorCertificationInfo.vue');
// let MemberDiscount = () => import('../views/UserCenter/member-discount/MemberDiscount.vue');
// let Partner = () => import('../views/UserCenter/partner/Partner.vue');
let LoginRecord = () => import('@/views/UserCenter/LoginRecord/LoginRecord.vue');
let Messages = () => import('@/views/UserCenter/Messages/Messages.vue');
// let EmailBind = () => import('../views/UserCenter/email-bind/EmailBind.vue');
let MaxRegisterBind = () => import('@/views/UserCenter/MaxRegisterBind/MaxRegisterBind.vue');
let PhoneBind = () => import('@/views/UserCenter/PhoneBind/PhoneBind.vue');
let GoogleVerificationBind = () => import('@/views/UserCenter/GoogleVerificationBind/GoogleVerificationBind.vue');
let LoginPwdBind = () => import('@/views/UserCenter/LoginPwdBind/LoginPwdBind.vue');
// let PreventDeceiveCode = () => import('../views/UserCenter/prevent-deceive-code/PreventDeceiveCode.vue');
let TradersPwdBind = () => import('@/views/UserCenter/TradersPwdBind/TradersPwdBind.vue');
// let RelationTeam = () => import('@/views/UserCenter/RelationTeam/RelationTeam.vue');


let Exchange = () => import('@/views/Exchange/index.vue');

let About = () => import('../views/About/About.vue');
let ContactUs = () => import('../views/ContactUs/ContactUs.vue');
let CompanyProfile = () => import('../views/CompanyProfile/CompanyProfile.vue');
let Invite = () => import('../views/Invite/Invite.vue');

let CoinToCoinAccount = () => import('../views/CoinToCoinAccount/CoinToCoinAccount.vue');
let FinancialRecords = () => import('../views/CoinToCoinAccount/FinancialRecords/FinancialRecords.vue');
let AddressManagement = () => import('../views/CoinToCoinAccount/WalletMgmt/AddressManagement.vue');
let AllTransaction = () => import('../views/CoinToCoinAccount/AllTxn/Transaction.vue');
let Orders = () => import('../views/Orders/Orders.vue');
let Markets = () => import('../views/Markets/Markets.vue');

/*let Affiliate = () => import('../views/Affiliate/Affiliate.vue');
let AffiliateInvite = () => import('../views/AffiliateInvite/AffiliateInvite.vue');*/
let AffiliatePolicy = () => import('../views/Legal-docs/affiliate-policy/AffiliatePolicy.vue');
let PartnerPolicy = () => import('../views/Legal-docs/partner-policy/PartnerPolicy.vue');
let TermsOfUse = () => import('../views/Legal-docs/terms-of-use/TermsOfUse.vue');
let AMLPolicy = () => import('../views/Legal-docs/aml-policy/AMLPolicy.vue');
let RiskStatement = () => import('../views/Legal-docs/risk-statement/RiskStatement.vue');
let PrivacyPolicy = () => import('../views/Legal-docs/privacy-policy/PrivacyPolicy.vue');
let InvitePoster = () => import('../views/AffiliateInvite/invite-poster/InvitePoster.vue');

let HelpCenter = () => import('../views/HelpCenter/HelpCenterList.vue');
let AnnouncementList = () => import('../views/Announcement/AnnouncementList/AnnouncementList.vue');
let AnnouncementDetail = () => import('../views/Announcement/AnnouncementDetail/AnnouncementDetail.vue');
let ApplicationForm = () => import('../views/ApplicationForm/ApplicationForm.vue');
// const MyReward = () => import('../views/UserCenter/my-reward/MyReward.vue');


// Sto
/*let Sto = () => import('@/views/Sto/index.vue');
let StoListing = () => import('@/views/Sto/sto-main/listing/index.vue');
let StoDetails = () => import('@/views/Sto/sto-main/details/index.vue');
let StoFundraiser = () => import('@/views/Sto/fundraiser/index');
let StoFundraiserApplicationForm = () => import('@/views/Sto/fundraiser/application-form/index');
let StoFundraiserApplicationSuccess = () => import('@/views/Sto/fundraiser/application-form/success');
let StoFundraiserPayment = () => import('@/views/Sto/fundraiser/payment');*/

let PaymentGateway = () => import('@/views/PaymentGateway/index.vue');
export default [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: Home
      },
      {
        path: '/coin-to-coin-account',
        name: 'coinToCoinAccount',
        meta: { requireAuth: true },
        component: CoinToCoinAccount,
        children: [
          {
            path: '/financial-records',
            name: 'financialRecords',
            meta: { requireAuth: true },
            component: FinancialRecords
          },
          {
            path: '/address-management',
            name: 'addressManagement',
            meta: { requireAuth: true },
            component: AddressManagement
          },
          {
            path: '/all-transaction',
            name: 'allTransaction',
            meta: { requireAuth: true },
            component: AllTransaction
          }
        ]
      },
      // 用户中心
      {
        path: '/usercenter',
        name: 'usercenter',
        meta: { requireAuth: true },
        component: UserCenter,
        children: [
          {
            path: 'account-management',
            name: 'account-management',
            component: AccountManagement,
            meta: { requireAuth: true }
          },
          // {
          //   path: '/usercenter/realname',
          //   name: 'realname',
          //   component: RealName,
          //   meta: { requireAuth: true },
          // },
          // 身份认证
          {
            path: 'authentication',
            name: 'authentication',
            component: Authentication,
            meta: { requireAuth: true },
            children: [
              // 实名认证
              {
                path: 'real-name',
                name: 'real-name',
                component: RealName,
                meta: { requireAuth: true }
              }
            ]
          },
          /*{
            path: 'my-reward',
            name: 'my-reward',
            component: MyReward,
            meta: { requireAuth: true }
          },*/
          // {
          //   path: '/usercenter/realName-info',
          //   name: 'realName-info',
          //   component: RealNameInfo,
          //   meta: { requireAuth: true },
          // },
          // {
          //   path: '/usercenter/senior-certification',
          //   name: 'senior-certification',
          //   component: SeniorCertification,
          //   meta: { requireAuth: true },
          // },
          // {
          //   path: '/usercenter/senior-certification-info',
          //   name: 'senior-certification-info',
          //   component: SeniorCertificationInfo,
          //   meta: { requireAuth: true },
          // },
          // {
          //   path: '/usercenter/fee-rate',
          //   name: 'fee-rate',
          //   component: FeeRate,
          //   meta: { requireAuth: true },
          // },
          // {
          //   path: '/usercenter/address-book',
          //   name: 'address-book',
          //   component: AddressBook,
          //   meta: { requireAuth: true },
          // },
          // {
          //   path: '/usercenter/member-discount',
          //   name: 'member-discount',
          //   component: MemberDiscount,
          //   meta: { requireAuth: true },
          // },
          // {
          //   path: '/usercenter/partner',
          //   name: 'partner',
          //   component: Partner,
          //   meta: { requireAuth: true },
          // },
          {
            path: 'login-record',
            name: 'login-record',
            component: LoginRecord,
            meta: { requireAuth: true }
          },
          {
            path: 'messages',
            name: 'messages',
            component: Messages,
            meta: { requireAuth: true }
          },
          // {
          //   path: '/usercenter/email-bind',
          //   name: 'email-bind',
          //   component: EmailBind,
          //   meta: { requireAuth: true },
          //   children: [
          //     {
          //       // isUpdate 表示是否为修改，值为1则表示修改，2表示查看
          //       path: '/usercenter/email-bind',
          //       name: 'email-bind_update',
          //       component: EmailBind,
          //       meta: { requireAuth: true },
          //     },
          //   ],
          // },
          {
            path: 'phone-bind',
            name: 'phone-bind',
            component: PhoneBind,
            meta: { requireAuth: true }
          },
          {
            path: 'google-verification-bind',
            name: 'google-verification-bind',
            component: GoogleVerificationBind,
            meta: { requireAuth: true }
          },
          {
            path: 'login-pwd-bind',
            name: 'login-pwd-bind',
            component: LoginPwdBind,
            meta: { requireAuth: true }
          },
          {
            path: 'traders-pwd-bind',
            name: 'traders-pwd-bind',
            component: TradersPwdBind,
            meta: { requireAuth: true }
          },
          {
            path: 'max-register-bind',
            name: 'max-register-bind',
            component: MaxRegisterBind,
            meta: { requireAuth: true }
          },
          /*{
            path: 'relation-team',
            name: 'relation-team',
            component: RelationTeam,
            meta: { requireAuth: true }
          }*/
        ]
      },
      {
        path: '/orders',
        name: 'orders',
        meta: { requireAuth: true },
        component: Orders
      },
      {
        path: '/markets',
        name: 'markets',
        component: Markets
      },
      {
        path: '/company-profile',
        name: 'company-profile',
        component: CompanyProfile
      },
      {
        path: '/about',
        name: 'about',
        component: About
      },
      {
        path: '/contact-us',
        name: 'contact-us',
        component: ContactUs
      },
      {
        path: '/invite',
        name: 'invite',
        component: Invite
      },
      {
        path: '/legal/terms-of-use',
        name: 'terms-of-use',
        component: TermsOfUse
      },
      {
        path: '/legal/aml-policy',
        name: 'aml-policy',
        component: AMLPolicy
      },
      {
        path: '/legal/risk-statement',
        name: 'risk-statement',
        component: RiskStatement
      },
      {
        path: '/legal/privacy-policy',
        name: 'privacy-policy',
        component: PrivacyPolicy
      },
      {
        path: '/legal/affiliate-policy',
        name: 'affiliate-policy',
        component: AffiliatePolicy
      },
      {
        path: '/legal/partner-policy',
        name: 'partner-policy',
        component: PartnerPolicy
      },
      /*{
        path: '/affiliate',
        name: 'affiliate',
        component: Affiliate,
      },
      {
        path: '/affiliate-invite',
        name: 'affiliate-invite',
        component: AffiliateInvite,
        meta: { requireAuth: true }
      },*/
      {
        path: '/invitation',
        name: 'invite-poster',
        component: InvitePoster
      },
      {
        path: '/help',
        name: 'help',
        component: HelpCenter
      },
      {
        path: '/announcement',
        name: 'announcement',
        component: AnnouncementList
      },
      {
        path: '/announcement/detail',
        name: 'announcement-detail',
        component: AnnouncementDetail
      },
      {
        path: '/application-form',
        name: 'application-form',
        component: ApplicationForm
      },
      /*{
        path: '/sto',
        name: 'sto',
        component: Sto,
        children: [
          {
            path: '',
            name: 'sto-listing',
            component: StoListing
          },
          {
            path: 'details/:id',
            name: 'Sto-listing-details',
            component: StoDetails
          },
          {
            path: 'dashboard',
            meta: { requireAuth: true },
            name: 'Sto-listing-dashboard',
            component: StoListing
          },
          {
            path: 'dashboard/details/:id',
            meta: { requireAuth: true },
            name: 'Sto-dashboard-listing-details',
            component: StoDetails
          },
          {
            path: 'fundraiser',
            component: StoFundraiser,
            children: [
              {
                path: 'application/new',
                meta: { requireAuth: true },
                name: 'fundraiser-application-new',
                component: StoFundraiserApplicationForm
              },
              {
                path: 'application/:id',
                meta: { requireAuth: true },
                name: 'fundraiser-application',
                component: StoFundraiserApplicationForm
              },
              {
                path: 'payment/status/:id',
                meta: { requireAuth: true },
                name: 'Sto-fundraiser-application-success',
                component: StoFundraiserApplicationSuccess
              },
              {
                path: 'payment/:id',
                name: 'Sto-fundraiser-payment',
                component: StoFundraiserPayment
              }
            ]
          },
          {
            path: '/pay-sto',
            meta: { requireAuth: true },
            name: 'pay-sto',
            component: PaymentGateway
          }
          // {
          //   path: "about",
          //   name: 'Sto-About',
          //   component: Sto_Main_About,
          // }
          //                 {
          //   path: "fund",
          //   name: "Sto-Fund",
          //   component: Sto_Fund,
          // },
        ]
      }*/
    ]
  },
  {
    path: '/account-layout',
    name: 'AccountLayout',
    component: AccountLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login
      },
      {
        path: '/register',
        name: 'register',
        component: Register
      },
      {
        path: '/forget-pwd',
        name: 'ForgetPwd',
        component: ForgetPwd
      },
      {
        path: '/reactivation',
        name: 'reactivation',
        component: Reactivation
      },
    ]
  },

  {
    path: '/exchange-layout',
    component: ExchangeLayout,
    children: [
      {
        path: '/exchange',
        name: 'exchange',
        component: Exchange
      }
    ]
  },

  /*{
    path: '/sto',
    name: 'sto',
    component: Sto,
    children: [
      {
        path: "",
        name: "sto-listing",
        component: StoListing,
      },
      {
        path: "details/:id",
        name: "Sto-listing-details",
        component: StoDetails,
      },
      {
        path: "dashboard",
        meta: { requireAuth: true },
        name: "Sto-listing-dashboard",
        component: StoListing,
      },
      {
        path: "dashboard/details/:id",
        meta: { requireAuth: true },
        name: "Sto-dashboard-listing-details",
        component: StoDetails,
      },
      {
        path: 'fundraiser',
        component: StoFundraiser,
        children: [
          {
            path: 'application/new',
            meta: { requireAuth: true },
            name: 'fundraiser-application-new',
            component: StoFundraiserApplicationForm
          },
          {
            path: 'application/:id',
            meta: { requireAuth: true },
            name: 'fundraiser-application',
            component: StoFundraiserApplicationForm
          },
          {
            path: 'payment/status/:id',
            meta: { requireAuth: true },
            name: 'Sto-fundraiser-application-success',
            component: StoFundraiserApplicationSuccess
          },
          {
            path: 'payment/:id',
            name: 'Sto-fundraiser-payment',
            component: StoFundraiserPayment
          },
        ]
      },
      // {
      //   path: "about",
      //   name: 'Sto-About',
      //   component: Sto_Main_About,
      // }
      //                 {
      //   path: "fund",
      //   name: "Sto-Fund",
      //   component: Sto_Fund,
      // },
    ]
  },*/
];
